<template>
  <!-- display:none inlcuido pois o menu estava ocupando um espaço no outras opções fazendo os botões irem pra baixo -->
  <v-menu v-model="openMoreLegends" offset-y style="display:none">
    <template v-slot:activator="{ on, attrs }">
      <v-btn :id="'showMoreFields' + task_id" @click="toggle" small color="grey lighten-4" fab class="mx-0" >
        <v-icon color="grey darken-1">list</v-icon>
      </v-btn>
    </template>
    <v-card :width="300">
      <v-list v-if="openMoreLegends" two-line class="others-fields">
        <v-subheader style="color: black;"> {{title}} </v-subheader>
        <v-divider :inset="false"></v-divider>
        <v-progress-linear v-if="loadingMoreField" height="5" :indeterminate="true"></v-progress-linear>
        <template v-for="(item, index) in items">
          <!-- click utilizado para formatação do campo -->
          <v-list-tile :key="index" @click="">
            <v-list-tile-content>
              <v-list-tile-sub-title v-html="item.subtitle"></v-list-tile-sub-title>
              <v-divider :inset="false"></v-divider>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
  import moment from 'moment'
  import momentDurationFormatSetup from 'moment-duration-format'

  momentDurationFormatSetup(moment)
  export default {
    name: 'POtherField',
    props: {
      othersFields: Array,
      reload: false,
      task_id: null,
      title: {
        type: String,
        default: 'Outros campos'
      }
    },
    data: () => ({
      loadingMoreField: false,
      openMoreLegends: false,
      items: []
    }),
    methods: {
      otherFields () {
        let data = []
        this.othersFields.map(function (currentValue, index, arr) {
          data.push({
            subtitle: '<span class=\'text--primary\'>' + currentValue.field + ': </span>' + this.getIdText(currentValue.value)
          })
        }, this)
        return data
      },
      getDateText (text) {
        let result
        if (text.length < 12) {
          result = moment(text).format('DD/MM/YYYY')
        } else {
          result = moment(text).format('DD/MM/YYYY - HH:mm:ss')
        }
        return result
      },
      getIdText (text) {
        let result
        if (text == null) {
          result = ''
        } else if (typeof text === 'boolean') {
          result = text ? 'Sim' : 'Não'
        } else if (typeof text === 'number') {
          result = text
          // foi inserido o text.length pois toda data é maior que 9 pra não dar problemas quando vier um numero que devia ser string
        } else if ((text.length > 9) && (moment(text, 'YYYY-MM-DD', true).isValid() || moment(text, 'YYYY-MM-DD HH:mm:ss', true).isValid())) {
          result = this.getDateText(text)
        } else {
          result = text
        }
        return result
      },
      toggle () {
        this.loadingMoreField = true
        if (!this.openMoreLegends) {
          this.$http.get(`api/get_other_fields/${this.task_id}`).then(response => {
            this.loadingMoreField = false
            console.log(response.body)
            this.items = [
              {field: this.translate('table.tasks.field.client_id'), value: response.body.client},
              {field: this.translate('table.tasks.field.begin'), value: moment(String(response.body.begin)).format('DD/MM/YYYY')},
              {field: this.translate('table.tasks.field.column_duration'), value: moment.duration(parseInt(response.body.column_duration), 'seconds').format('hh [hrs] mm [min] ss [seg]')},
              {field: this.translate('table.tasks.field.column_all_duration'), value: moment.duration(parseInt(response.body.column_all_duration), 'seconds').format('hh [hrs] mm [min] ss [seg]')},
              {field: this.translate('table.tasks.field.category_id'), value: response.body.category},
              {field: this.translate('table.tasks.field.note '), value: response.body.note}
            ]
            this.items.map(function (currentValue, index, arr) {
              currentValue.subtitle = '<span class=\'text--primary\'>' + currentValue.field + ': </span>' + currentValue.value
            })
            console.log(this.items)
          })
        }
        this.openMoreLegends = !this.openMoreLegends
      }
    }
  }
</script>

<style>
  .others-fields a {
    height: 25px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/PRequestMoreFields.vue